<app-header></app-header> 

<!-- Page Header Start -->
<div class="container-fluid page-header py-5">
    <div class="container text-center pd-t-120 pd-b-120">
        <h1 class="display-5 text-white mb-4">Our Services</h1>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
                <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                <li class="breadcrumb-item"><a routerLink="/">Pages</a></li>
                <li class="breadcrumb-item" aria-current="page">Services</li>
            </ol>
        </nav>
    </div>
</div>
<!-- Page Header End -->

<!-- Fact Start -->
<div class="container-fluid bg-color-secondary py-5">
  <div class="container">
    <div class="row">
      
      <!-- Loop over facts array using *ngFor -->
      <div *ngFor="let fact of facts" class="col-lg-3">
        <div class="d-flex counter">
          <h1 class="me-3 color-dark counter-value">{{ fact.value }}</h1>
          <h5 class="text-white mt-1">{{ fact.label }}</h5>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- Fact End -->

<!-- Services Start -->
<div class="container-fluid services py-5 mb-5">
  <div class="container">
    <div class="text-center mx-auto pb-5 wow fadeIn" data-wow-delay=".3s" style="max-width: 600px;">
      <h5 class="color-primary">Our Services</h5>
      <h1>Design, Strategy & Technology Aligned for Your Success</h1>
    </div>
    
    <div class="row g-5 services-inner">
      
      <!-- Loop over services array using *ngFor -->
      <div *ngFor="let service of services" class="col-md-6 col-lg-4 wow fadeIn" [attr.data-wow-delay]="service.delay">
        
        <div class="services-item bg-light">
          <div class="p-4 text-center services-content">
            <div class="services-content-icon">
              <i [class]="service.icon + ' fa-7x mb-4 color-primary'"></i>
              <h4 class="mb-3">{{ service.title }}</h4>
              <p class="mb-4">{{ service.description }}</p>
              <a [routerLink]="service.link" class="btn btn-secondary text-white px-5 py-3 rounded-pill">Read More</a>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
<!-- Services End -->